export interface TopAirline {
    id: string
    name: string
    logo?: string
}

export const TOP_AIRLINES: TopAirline[] = [
    { id: 'sv', name: 'Saudi Arabian Airlines' },
    { id: 'f3', name: 'Flyadeal' },
    { id: 'ku', name: 'Kuwait Airways' },
    { id: 'g9', name: 'Air Arabia' },
    { id: '9w', name: 'Jet Airways' },
    { id: 'gf', name: 'Gulf Air' },
    { id: 'et', name: 'Ethiopian Airlines' },
    { id: 'ms', name: 'Air Cairo' },
    { id: 'me', name: 'Middle East Airlines' },
    { id: 'b8', name: 'Eritrean Airlines' },
    { id: 'xy', name: 'Flynas' },
    { id: 'np', name: 'Nile Air' },
    { id: 'fz', name: 'Flydubai Airways' },
    { id: 'ul', name: 'SriLankan Airlines' },
    { id: 'pr', name: 'Philippine Airlines' },
    { id: 'wy', name: 'Oman Air' },
    { id: 'ey', name: 'Etihad Airways' },
    { id: 'sq', name: 'Singapore Airlines' },
    { id: 'pg', name: 'Bangkok Airways' },
    { id: 'ov', name: 'Salam Air' },
    { id: 'ne', name: 'Nesma Airlines' },
    { id: 'ms', name: 'Egypt Air' },
    { id: 'tk', name: 'Turkish Airlines' },
    { id: 'ba', name: 'British Airways' },
    { id: 'lh', name: 'Lufthansa' },
    { id: 'rj', name: 'Royal Jordanian' },
    { id: 'af', name: 'Air France' },
    { id: 'at', name: 'Royal Air Maroc' },
    { id: '5j', name: 'Cebu Pacific Air' },
    { id: 'vy', name: 'Vueling airlines' }
]
